import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import { FormContext } from '../Form';
import { FormField, InputAndErrorContainer } from '../FormField';
import { SearchSelect, SearchSelectOptions } from './SearchSelect';

type Props<TValue> = {
  options: SearchSelectOptions<TValue>;
  name: string;
  label: string | null;
  onChange?: (newValue: TValue | null) => void;
  mapValueToKey?: (value: TValue) => string;
};

export const SearchSelectField = <TValue,>({ options, name, label, onChange, mapValueToKey }: Props<TValue>) => {
  const formIsDisabled = useContext(FormContext).isDisabled;

  return (
    <FormField name={name} label={label}>
      {({ form, field, $isValid, $isInvalid }) => {
        const onChangeWrapper = (newValue: TValue | null) => {
          form.setFieldValue(field.name, newValue);
          if (onChange != null) {
            onChange(newValue);
          }
        };

        return (
          <Container>
            <SearchSelect<TValue>
              {...field}
              onBlur={() => form.setFieldTouched(field.name, true)}
              options={options}
              onChange={onChangeWrapper}
              mapValueToKey={mapValueToKey}
              $isValid={$isValid}
              $isInvalid={$isInvalid}
              disabled={form.isSubmitting || formIsDisabled}
            />
          </Container>
        );
      }}
    </FormField>
  );
};

const Container = styled.div`
  width: 100%;

  ${InputAndErrorContainer}: {
    position: relative;
    z-index: 0;
  };
`;
